import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  ack_id: string().required(),
});

/**
 * SystemAckEvent
 *
 * - Esse evento é enviado pelo servidor para confirmar o recebimento de um evento enviado pelo cliente.
 * - Caso o evento enviado pelo cliente tenha falhado, o servidor irá enviar um evento de `SystemError` com o motivo do erro.
 */
export class SystemAckEvent extends CreateCommand(RealtimeEventType.SystemAcknowledge, SCHEMA) {}
